import { makeI18nField } from "../utils/i18nSchemas.js";

export const createGiveawaySchema = {
  type: "object",
  properties: {
    eventId: { type: "integer" },
    titleI18n: makeI18nField({ required: true, minLength: 1 }),
    descriptionI18n: makeI18nField(),
    pageId: { type: ["string", "null"] },
  },
  required: ["eventId"],
  additionalProperties: false,
};

export const getGiveawayByEventIdSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
    },
    required: ["eventId"],
  },
};

export const getGiveawayByIdSchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};

export const updateGiveawaySchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    type: "object",
    properties: {
      titleI18n: makeI18nField({ minLength: 1 }),
      descriptionI18n: makeI18nField(),
      status: {
        type: "string",
        enum: ["live", "closed", "draft", "published"],
      },
      pageId: { type: ["string", "null"] },
    },
    additionalProperties: false,
  },
};

export const deleteGiveawaySchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
};

export const addSponsorsToGiveawaySchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
    },
    required: ["id"],
  },
  body: {
    type: "object",
    properties: {
      sponsorIds: {
        type: "array",
        items: { type: "number" },
        minItems: 1,
      },
    },
    required: ["sponsorIds"],
    additionalProperties: false,
  },
};

export const removeSponsorFromGiveawaySchema = {
  params: {
    type: "object",
    properties: {
      id: { type: "number" },
      sponsorId: { type: "number" },
    },
    required: ["id", "sponsorId"],
  },
};

export const scanGiveawaySchema = {
  body: {
    type: "object",
    properties: {
      uniqueCode: { type: "string", minLength: 1 },
    },
    required: ["uniqueCode"],
    additionalProperties: false,
  },
};

export const web_addSponsorsToGiveawaySchema = {
  type: "object",
  properties: {
    sponsorIds: {
      type: "array",
      items: { type: "string" },
      minItems: 1,
    },
  },
  required: ["sponsorIds"],
  additionalProperties: false,
};

export const web_updateGiveawaySchema = updateGiveawaySchema.body;
export const GIVEAWAY_HISTORY_ACTIONS = {
  GIVEAWAY_UPDATED: "update_giveaway",
  SPONSORS_UPDATED: "update_sponsors",
  GIVEAWAY_SCANNED: "scan",
};
